import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrentCall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.5,
	height: 9,
	viewBox: "0 0 13.5 9",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M13.5,1.69V7.29c0,.34-.16,.64-.43,.81-.15,.1-.33,.15-.51,.15-.13,0-.27-.03-.39-.09l-2.42-1.11v.45c0,.83-.67,1.5-1.5,1.5H1.5c-.83,0-1.5-.67-1.5-1.5V1.5C0,.67,.67,0,1.5,0h6.75c.83,0,1.5,.67,1.5,1.5v.45l2.42-1.11c.29-.13,.63-.11,.9,.06,.27,.18,.43,.47,.43,.79Zm-4.88-.19c0-.21-.17-.38-.38-.38H1.5c-.21,0-.38,.17-.38,.38V7.5c0,.21,.17,.38,.38,.38h6.75c.21,0,.38-.17,.38-.38V1.5Zm-1.31,3c0,.31-.25,.54-.58,.54h-1.31v1.35c0,.29-.23,.54-.54,.54s-.56-.25-.56-.58v-1.31h-1.33c-.29,0-.54-.23-.54-.54s.25-.56,.54-.56h1.33v-1.33c0-.29,.25-.54,.56-.54s.54,.25,.54,.54v1.33h1.33c.31,0,.56,.25,.56,.56ZM12.38,1.98l-2.62,1.2v2.63l2.62,1.2V1.98Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCurrentCall);
export default ForwardRef;
